import React, { useState } from 'react'
import CardMembershipIcon from 'components/material-symbol/icons/CardMembership'
import AccountLinkRow from 'components/account-link-row'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import AccountCard from 'pages/account/account-details/account-card'
import { useMyPgaHopeGraduateCards } from 'pages/club/pga-hope-card/api-hooks'
import GraduateCardModal from 'pages/club/pga-hope-card/graduate-card-modal'
import { getLatestCard } from 'pages/club/pga-hope-card/utils'

// Shown only once a card has been issued, so golfers who never joined PGA HOPE
// see nothing. With the flag off the card query never runs.
const PgaHopeCardLink = ({ classes }) => {
  const [isEnabled] = useFeatureFlags([flags.FLAG_FEAT_PGA_HOPE_GRADUATE_CARD])
  const [open, setOpen] = useState(false)
  const { cards, fetchedAt, error, refetch } = useMyPgaHopeGraduateCards({
    skip: !isEnabled,
  })

  if (!isEnabled || cards.length === 0) return null

  return (
    <>
      <AccountCard title="PGA HOPE" classes={classes}>
        <AccountLinkRow
          onClick={() => {
            setOpen(true)
            refetch()
          }}
          icon={<CardMembershipIcon />}
          title="PGA HOPE Graduate Card"
          description="Show your digital card to redeem partner discounts."
        />
      </AccountCard>
      <GraduateCardModal
        open={open}
        onClose={() => setOpen(false)}
        card={getLatestCard(cards)}
        verifiedOn={fetchedAt}
        verificationFailed={Boolean(error)}
      />
    </>
  )
}

export default PgaHopeCardLink
